import { useTheme } from 'styled-components';
import Icon from '../Icon';

/**
 * @param {boolean} isFooter
 * @param {any} theme
 * @returns {any}
 */
const getLogo = (isFooter, theme) => {
  let { logo } = theme;

  if (isFooter) {
    logo = theme.footer?.logoFooter || theme?.logoMobile || theme.logo;
  }

  return logo;
};

/**
 * @param {LogoProps} props
 * @returns {React.ReactElement} The rendered component
 */
const Logo = ({ className, isFooter }) => {
  const theme = useTheme();
  const logo = getLogo(!!isFooter, theme);
  return (
    <div className={className}>
      <Icon icon={logo} />
    </div>
  );
};

export default Logo;
